import React from "react";
import PropTypes from "prop-types";
import { PackagesNoResultsQuery } from "./PackagesNoResultsQuery";
import { RCL } from "../RCL";
import { CardsContainerGrid } from "../CardsContainer";
import { CardConnector } from "../../connectors/CardConnector";
import * as styles from "./NoResultsCards.module.scss";

const NoResultsCards = ({ locale }) => {
	const data = PackagesNoResultsQuery();

	const localeData = data?.find(x => x.node?.node_locale === locale);

	const cardData = localeData?.node.cards.map(card => ({
		heading: card.heading,
		image: card.image,
		link: {
			url: card.link.url,
			target: card.link.target,
			linkText: card.link.linkText,
		},
	}));

	return (
		<>
			<span className={styles.noResults}>
				<RCL searchKey="were-so-sorry-no-results-available" />
			</span>
			<span className={styles.noResultsSub}>
				<RCL searchKey="we-couldnt-find-exactly-what-you-were-looking-for-but-you-may-also-like" />
			</span>
			<CardsContainerGrid cardsPerRow={localeData?.node.itemsPerRow}>
				{cardData?.map((card, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<CardConnector key={`card-${index}`} data={card} />
				))}
			</CardsContainerGrid>
		</>
	);
};

NoResultsCards.propTypes = {
	locale: PropTypes.string.isRequired,
	offerType: PropTypes.string,
};

export default NoResultsCards;
export { NoResultsCards };
